import React from "react";
import HighlightOff from "@material-ui/icons/HighlightOff";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";
import { useSegment } from "analytics/segment";
import { useStore as useAuthStore } from "auth/store";
import { useErrorReporterFiltered } from "core/hooks/useErrorReporterFiltered";
import { useManageUser } from "core/queries/ManageUser";
import { UndoAction, addUndo } from "team/actions";
import { useStore as useTeamStore } from "team/store";

interface RemoveMemberButtonProps {
  userId: string;
}
export const RemoveMemberButton = ({ userId }: RemoveMemberButtonProps) => {
  const { state: authState } = useAuthStore();
  const errorReporter = useErrorReporterFiltered();
  const { track } = useSegment();
  const { dispatch } = useTeamStore();

  const variables = {
    userId,
    cityId: null,
  };

  const [removeUser] = useManageUser({
    awaitRefetchQueries: true,
    refetchQueries: ["GetTeam"],
    variables,
  });

  const cityId = authState.user?.cityId;
  const isDispatchDashboardAdmin = authState.user?.isDispatchDashboardAdmin;
  if (!cityId || !isDispatchDashboardAdmin) {
    return null;
  }

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    track({
      eventName: "user_row",
      action: "click",
      element: "remove_member_button",
      props: { userId },
    });

    removeUser()
      .then(response => {
        const mutatedUser = response.data?.manageUser?.user;
        if (mutatedUser) {
          dispatch(addUndo(UndoAction.REMOVE_MEMBER, mutatedUser));
        }
      })
      .catch(error => {
        errorReporter.notify(error);
      });
  };

  return (
    <CircleButton
      backgroundVariant="light"
      title="Remove team member"
      onClick={onClick}
    >
      <HighlightOff />
    </CircleButton>
  );
};
